.entityCard {
  margin-top: 16px;
}

/* The More trigger carries the dot */
.withDot {
  position: relative;
}

/* Unread dot: the Agents pill's badge tokens, with a ring so it reads on any bar background */
.unreadDot {
  position: absolute;
  /* Top right of the 44px target, clear of the kebab's top dot */
  top: 6px;
  right: 4px;
  width: 8px;
  height: 8px;
  border-radius: var(--tuna-shape-radius-pill);
  background-color: var(--tuna-palette-primary-main);
  box-shadow: 0 0 0 2px var(--tuna-surface-default);
  pointer-events: none;
}
